import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CameraService } from '../../../services/camera.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SpinnerService } from '../../../services/spinner.service';
import { Camera } from '../../../models/camera.model';
import { CameraModalComponent } from '../../../components/camera-modal/camera-modal.component';

@Component({
  selector: 'app-cameras-page',
  templateUrl: './cameras-page.component.html',
  styleUrl: './cameras-page.component.scss'
})
export class CamerasPageComponent {

  public neighborhoodId?: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    public cameraService: CameraService,
    private modalService: NgbModal,
    public spinnerService: SpinnerService
  ) {

    this.activatedRoute.params.subscribe(
      async params => {

        this.neighborhoodId = params['neighborhoodId'];

        await this.cameraService.getAll(
          this.neighborhoodId!
        );
      }
    );

  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR delete                               */
  /* -------------------------------------------------------------------------- */
  // region delete
  async delete(
    camera: Camera
  ) {
    const flag = confirm(
      `¿Está seguro que desea eliminar la cámara "${camera.description}"?`
    );

    if (flag) {
      await this.cameraService.delete(
        camera
      );
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                                 ANCHOR open                                */
  /* -------------------------------------------------------------------------- */
  // region open
  open(
    camera?: Camera
  ) {
    const modalRef = this.modalService.open(
      CameraModalComponent
    );
    
    modalRef.componentInstance.camera = camera;
    modalRef.componentInstance.neighborhoodId = this.neighborhoodId;
  }

  /* -------------------------------------------------------------------------- */
  /*                                 screenshot                                 */
  /* -------------------------------------------------------------------------- */
  // region screenshot
  async screenshot(
    camera: Camera
  ) {
    const flag = confirm(
      `Para tomar una screenshot de la cámara debe estar dentro de la misma red.\n¿Confirma que está en la red de "${camera.description}"?`
    );

    if (flag) {
      const imageBase64 = await this.cameraService.screenshot(
        camera
      );

      // console.log('imageBase64:', imageBase64);
      
      if(imageBase64) {

        const base64 = imageBase64.startsWith('data:')
          ? imageBase64
          : `data:image/jpeg;base64,${imageBase64}`;

        const win = window.open('', '_blank');

        if (win) {
          win.document.write(`
            <html>
              <head><title>Screenshot - ${camera.description}</title></head>
              <body style="margin:0; display:flex; justify-content:center; align-items:center; height:100vh; background:#000;">
                <img src="${base64}" style="max-width:100%; max-height:100%;" />
              </body>
            </html>
          `);
          win.document.close();
        }

      }
      
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                             ANCHOR watchCamera                             */
  /* -------------------------------------------------------------------------- */
  // region watchCamera
  watchCamera(camera: Camera) {
    const flag = confirm(
      `Para ver esta cámara debe estar dentro de la misma red. ¿Confirma que si entra dentro de la misma red de la cámara ${camera.description}?`
    );

    if (flag) {

      const url = `rtsp://${camera.username}:${camera.password}@${camera.ip}:554${camera.params}`;

      window.open(
        url, '_blank'
      );
    }
  }

}
